/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CheckCircle, Close } from '@material-ui/icons';
import { CircularProgress } from '@material-ui/core';
import { useUserInfo, useOutboundNumbers } from '~/hooks';
import * as actions from '~/store/actions';
import * as lib from '~/dependencies';
import api from '~/services';
import log from '~/helpers/log';
import { DrawerComponent } from './styles';

export default function ExtensionsSelector() {
  // HOOKS
  const { t } = lib.useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [outboundNumbers, setOutboundActions] = useOutboundNumbers([]);
  const [userInfo, setUserInfo] = useUserInfo(null);

  // STATES
  const [extensions, setExtensions] = useState([]);
  const [extensionSelected, setExtensionSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  // SELECTORS
  const auth = useSelector(state => state.auth && state.auth);
  const isAdmin = useSelector(state => state.auth && state.auth.isAdmin);

  // EFFECTS
  useEffect(() => {
    if (auth && !auth.userExtension) {
      setOpen(true);
    }
  }, [auth]);

  function toggleDrawer(value) {
    setOpen(value);
    // Clean tokens If users close the screen without select an extension
    dispatch(actions.logout());
  }

  useEffect(() => {
    setUserInfo();
  }, [setUserInfo]);

  useEffect(() => {
    async function fetchExtensions() {
      try {
        const response = await api.accounts.get.allExtensions();
        if (response && response.data) {
          const extensionsFilted = response.data.filter(
            e => e.extension_is_used !== 1
          );
          setExtensions(extensionsFilted);
        }
      } catch (err) {
        log.error('Failed to execute the fetchExtensions function.', err);
      }
    }
    // if (userInfo && !userInfo.outbound_cli) {}
    if (userInfo && !userInfo.userExtension) {
      setOutboundActions('fetch');
      fetchExtensions();
      setOpen(true);
    }
  }, [userInfo, setOpen, setOutboundActions]);

  async function selecExtension(extension) {
    setExtensionSelected(extension);
    setLoading(true);

    let number = null;

    if (userInfo && !userInfo.outbound_cli) {
      number =
        outboundNumbers && outboundNumbers.numbers.length > 0
          ? outboundNumbers.numbers[0].number
          : null;
    }

    try {
      await api.accounts.post.setExtension({ extension });
      if (!number) {
        await api.accounts.post.outboundNumberChange({ number });
      }
      // toggleDrawer(false);
      await setUserInfo();
      setLoading(false);
      history.push('/app');
    } catch (err) {
      log.error('Failed to execute the selecExtension function.', err);
      setLoading(false);
    }
  }

  return (
    <>
      <DrawerComponent anchor="top" open={open}>
        <div id="boxTitle">
          <span className="title">
            {t('components.extensionsSelector.title')}
          </span>
          <Close className="close" onClick={() => toggleDrawer(false)} />
        </div>
        {extensions &&
          isAdmin &&
          Object.values(extensions).map(e => (
            <div
              className="rowSelect"
              key={e.number}
              value={e.number}
              onClick={() => selecExtension(e.number)}
              onKeyPress={() => selecExtension(e.number)}
              role="button"
              tabIndex={0}>
              <div className="left">
                <span>{`${e.number} - ${e.name}`}</span>
              </div>
              <div className="right">
                {extensionSelected && extensionSelected === e.number && (
                  <CheckCircle className="check-icon" />
                )}
              </div>
            </div>
          ))}

        {loading && <CircularProgress className="loading" />}
      </DrawerComponent>
    </>
  );
}
